import Types from '../actions/Types'

const initialState = {
  uid: null,
  token: null,
  role: null,
};

export default (state = initialState, {type, payload}) => {
  switch (type) {
  case Types.SET_USER:
    return payload;
  case Types.LOGOUT:
    return initialState;
  default:
    return state;
  }
}



// WEBPACK FOOTER //
// ./src/reducers/user.js